import { defineMessages } from 'react-intl-next';

// TODO: sync with content designer
export const messages = defineMessages({
	moreActions: {
		id: 'eoc-schedule.ui.list.edit-schedule.header.more-actions',
		defaultMessage: 'More actions for schedule',
		description: 'More actions button for schedule settings.',
	},
	nameEmptyValidationError: {
		id: 'eoc-schedule.ui.list.edit-schedule.header.name-empty-validation-error',
		defaultMessage: 'Schedule name cannot be empty.',
		description: 'Validation error when text is empty.',
	},
	nameLongValidationError: {
		id: 'eoc-schedule.ui.list.edit-schedule.header.name-long-validation-error',
		defaultMessage: 'Schedule name cannot be more than {length} characters.',
		description: 'Validation error when text is too long.',
	},
	editScheduleName: {
		id: 'eoc-schedule.ui.list.edit-schedule.header.edit-schedule-name',
		defaultMessage: 'Edit schedule name',
		description: 'Label for inline edit of schedule name.',
	},
	editScheduleTimezone: {
		id: 'eoc-schedule.ui.list.edit-schedule.header.edit-schedule-timezone',
		defaultMessage: 'Edit schedule timezone',
		description: 'Label for inline edit of schedule timezone.',
	},
});
